import { useMemo } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

import { SummaryCards } from './SummaryCards';
import { StudentCard } from './StudentCard';
import { RecentLogs } from './RecentLogs';
import { IClassAttendanceDashboard } from 'services/SchoolClass/types';

export interface ClassAttendanceTabProps {
  state: {
    attendanceData?: IClassAttendanceDashboard;
    isFetchingAttendance: boolean;
  };
}

export function ClassAttendanceTab({ state }: ClassAttendanceTabProps) {
  const { attendanceData, isFetchingAttendance } = state;

  const sortedStudents = useMemo(() => {
    if (!attendanceData || !attendanceData.students) {
      return [];
    }

    // 2. Só faz o spread e o sort se tiver certeza que os dados existem
    return [...attendanceData.students].sort((a: any, b: any) => {
      if (a.isActive === false && b.isActive !== false) return 1;
      if (a.isActive !== false && b.isActive === false) return -1;
      return 0; 
    });
  }, [attendanceData]);

  if (isFetchingAttendance && !attendanceData) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flex: 1, height: '200px' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!attendanceData || !attendanceData.students || attendanceData.students.length === 0) {
    return (
      <Box sx={{ p: 4, textAlign: 'center' }}>
        <Typography variant="body1" color="text.secondary" fontWeight="bold">
          Nenhum aluno ou responsável vinculado a esta turma para rastrear presença.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', gap: 3, flexDirection: { xs: 'column', lg: 'row' }, flex: 1, minHeight: 0 }}>
      
      {/* Coluna Principal (Cards + Grid) */}
      <Box sx={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: 3 }}>
        <SummaryCards 
          presente={attendanceData.totalPresent} 
          ausente={attendanceData.totalAbsent} 
          atrasado={attendanceData.totalLate} 
          total={attendanceData.totalStudents} 
        />
        
        <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))', gap: 2 }}>
          {sortedStudents.map((student) => (
            <StudentCard key={student.id} student={student} />
          ))}
        </Box>
      </Box>

      {/* Coluna Lateral (Logs) */}
      <Box sx={{ width: { xs: '100%', lg: 280 }, flexShrink: 0, display: 'flex', flexDirection: 'column' }}>
        <RecentLogs logs={attendanceData.recentLogs} />
      </Box>
      
    </Box>
  );
}